export const AttestationType = {
  FEES_CURRENT: 'FeesCurrent',
  BORROWER_IDENTITY_VERIFIED: 'BorrowerIdentityVerified',
};

export const ATTESTATIONS = [
  {
    type: AttestationType.FEES_CURRENT,
    label: 'Fees reflect the current lock/quote',
    description:
      "The fees on this Loan Estimate match the borrower's current locked rate or quote.",
  },
  {
    type: AttestationType.BORROWER_IDENTITY_VERIFIED,
    label: 'Borrower identity verified',
    description: 'I have verified the identity of each borrower receiving this disclosure.',
  },
];

export const SendStatus = {
  IDLE: 'idle',
  SENDING: 'sending',
  BLOCKED_READINESS: 'blockedReadiness',
  UNAVAILABLE: 'unavailable',
  NO_SEND_ACTION: 'noSendAction',
  ERROR: 'error',
  SENT: 'sent',
};

export const SEND_COPY = {
  title: 'Send disclosures',
  subtitle:
    'Confirm the attestations below, then send the initial Loan Estimate to every signer. Sending is final — the package leaves for the borrowers immediately.',
  attestationsTitle: 'Compliance attestations',
  attestationsHint:
    "Both attestations are required and are recorded to the loan's activity log before the package is sent.",
  summaryTitle: 'What will be sent',
  actionLabel: 'Send action',
  resolvingAction: 'Resolving the send action…',
  noSendActionValue: 'Not resolved',
  readinessBlocked:
    'A change made after preview means the loan is no longer ready to send. Review Step 1 — the flagged items must be resolved before you can send.',
  unavailable:
    "The attestation service is unavailable, so disclosures can't be sent right now. Attestations are compliance-mandatory and must be recorded before sending — try again shortly.",
  noSendAction:
    'No Initial Disclosures send action could be confidently identified for this loan, so sending is blocked to avoid firing the wrong package. Ask your admin to confirm a Send Form Bundles action is configured for the Initial Disclosures bundle.',
  error: 'The disclosures could not be sent. Please try again.',
  errorLead: 'The disclosures could not be sent:',
};

// Feedback for the best-effort physical-mail dispatch that rides after a successful send — its
// outcome never flips the overall send status, since the e-signed package already went out.
export const MAIL_DISPATCH_COPY = {
  dispatched: 'The physical mail package was dispatched to your configured mail provider.',
  failed:
    'The disclosures were sent, but the physical mail dispatch failed. Check Integration Studio -> Lender Integrations, or use Mark as mailed once the letter goes out.',
  notConfigured:
    'The disclosures were sent, but no Mail Document Package action is configured on this loan yet. Use Mark as mailed once the letter goes out.',
};
